import { defineStore } from 'pinia';
import { createVNode, render } from 'vue';
import dialogListCmp from './dialogList.vue';

const dialogStore = defineStore('dialogStore', {
    state: () => ({
        dialogs: {
            // dialog configs will go here
        }
    }),
    getters: {},
    actions: {
        initDialogList() {
            if (document.getElementById('dialog-list-container')) return;
            let elem = document.body;
            let vnode = createVNode(dialogListCmp);
            vnode.appContext = { ...vueApp._context };
            render(vnode, elem);
        },
        createDialog(dialogName, config) {
            this.initDialogList();
            this.dialogs[dialogName] = config;
        },
        openDialog(dialogName, config) {
            if (!config) config = {};
            if (!this.dialogs[dialogName]) this.createDialog(dialogName, config);
            this.dialogs[dialogName].opened = true;
        },
        closeDialog(dialogName) {
            if (this.dialogs[dialogName]) this.dialogs[dialogName].opened = false;
        },
        closeAllDialogs() {
            for (let dName in this.dialogs) {
                if (dName === 'length') continue;
                if (this.dialogs[dName]) this.dialogs[dName].opened = false;
            }
        }
    }
});

export { dialogStore };
